import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import IntervalAction from 'components/IntervalAction';
import { blackoutEnabled, blackoutDurationOverride } from 'helpers/ConfigHelper';
import { fetchBlackoutDefinition } from './BlackoutDefinitionFetcherActions';

class BlackoutDefinitionFetcher extends Component {
  static getEnabled = blackoutEnabledFromConfig => {
    const blackoutEnabledOverride = blackoutEnabled();
    const isBlackoutEnabledOverride = blackoutEnabledOverride !== null;
    return isBlackoutEnabledOverride ? blackoutEnabledOverride : blackoutEnabledFromConfig;
  };

  componentDidMount() {
    const { fetchBlackoutDefinition } = this.props;
    const blackout = _.get(window.ExternalConfig, 'blackout', {});
    const { enabled: blackoutEnabledFromConfig } = blackout;
    const enabled = BlackoutDefinitionFetcher.getEnabled(blackoutEnabledFromConfig);

    if (enabled) fetchBlackoutDefinition();
  }

  componentDidUpdate() {
    const { onComponentUpdate, definition } = this.props;
    onComponentUpdate(definition);
  }

  render() {
    const { fetchBlackoutDefinition } = this.props;
    const blackout = _.get(window.ExternalConfig, 'blackout', {});
    const {
      enabled: blackoutEnabledFromConfig,
      refreshDefinitionsIntervalMinutes: durationInMinutes,
    } = blackout;
    const enabled = BlackoutDefinitionFetcher.getEnabled(blackoutEnabledFromConfig);
    const durationInMinutesToMilliseconds = durationInMinutes ? durationInMinutes * 60000 : null;
    const durationOverride = blackoutDurationOverride();
    const duration = durationOverride || durationInMinutesToMilliseconds;

    if (!enabled || !duration) return null;

    return (
      <div>
        <IntervalAction action={fetchBlackoutDefinition} duration={duration} />
      </div>
    );
  }
}

BlackoutDefinitionFetcher.defaultProps = {
  definition: null,
  onComponentUpdate: () => {},
};

BlackoutDefinitionFetcher.propTypes = {
  fetchBlackoutDefinition: PropTypes.func.isRequired,
  onComponentUpdate: PropTypes.func,
  definition: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  definition: state.blackoutDefinitionFetcher.definition,
});

const mapDispatchToProps = {
  fetchBlackoutDefinition,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlackoutDefinitionFetcher);
